import _ from "lodash";
import { IProcessData, IAutoSavedProcessData } from "../model/IProcessData";
import { ThunkResult } from "shared/utilities";
import { State } from "../model/State";

const DEBOUNCE_WAIT = 2500;
const autosavePrefix = "frends_process_autoSave";
const autosavePurgeAfterHours = 48;

const saveToLocalStorageInternal = (state: State) => {
    if ((state.process?.id || state.process?.uniqueIdentifier) && (!state.uiState.isLoading || !state.uiState.isSaving || !state.uiState.hasChanges)) {
        const processData: IAutoSavedProcessData = Object.assign({} as IAutoSavedProcessData, state.process);
        processData.elementParameters = _.map(state.elements, (e) => e);
        processData.processVariables = state.processVariables;
        processData.autoSaved = new Date().toJSON();

        const key = generateKey(processData.id ?? processData.uniqueIdentifier);
        localStorage.setItem(key, JSON.stringify(processData));
    }
};

const debouncedSaveToLocalStorage = _.debounce(saveToLocalStorageInternal, DEBOUNCE_WAIT);

const generateKey = (processId: any) => {
    return `${autosavePrefix}:${processId}` as const;
};

export function purgeOldDataFromLocalStorage() {
    const currentDate = new Date();
    const removableItemKeys: string[] = [];

    Object.keys(localStorage).filter(k => k.startsWith(autosavePrefix)).forEach(function(key) {
        const data = localStorage.getItem(key);
        if (data) {
            const autoSavedValue = JSON.parse(data)["autoSaved"];
            if (autoSavedValue !== null) {
                const timeDiff = (currentDate.getTime() - new Date(Date.parse(autoSavedValue)).getTime()) / 36e5;
                if (timeDiff >= autosavePurgeAfterHours) {
                    removableItemKeys.push(key);
                }
            }
        }
     });

    removableItemKeys.forEach(itemKey => {
        localStorage.removeItem(itemKey);
    });
}

export function saveToLocalStorage(): ThunkResult<void, State> {
    return (dispatch, getState) => {
        try {
            debouncedSaveToLocalStorage(getState());
        } catch (err) {
            console.error(err);
        } finally {
            dispatch(saveToLocalStorageOk());
        }
    }
}

export function loadFromLocalStorage(processId: any) {
    purgeOldDataFromLocalStorage();
    if (processId) {
        const key = generateKey(processId);
        const data = localStorage.getItem(key);
        if (data) {
            return (JSON.parse(data) as IProcessData);
        }
    }

    return null;
}

export function removeFromLocalStorage(processId: any) {
    if (processId) {
        const key = generateKey(processId);
        localStorage.removeItem(key);
    }
}

export const SAVE_TO_LOCALSTORAGE_OK = "SAVE_TO_LOCALSTORAGE_OK";
export function saveToLocalStorageOk() {
    return {
        type: SAVE_TO_LOCALSTORAGE_OK
    };
}

export const RESTORED_FROM_LOCALSTORAGE_OK = "RESTORED_FROM_LOCALSTORAGE_OK";
export function restoredFromLocalStorageOk() {
    return {
        type: RESTORED_FROM_LOCALSTORAGE_OK
    };
}
